<template>
  <page-header-wrapper>
    <!--    <template v-slot:content>-->
    <!--      <div class="page-header-content">-->
    <!--        <div class="avatar">-->
    <!--          <a-avatar size="large" :src="avatar"/>-->
    <!--        </div>-->
    <!--        <div class="content">-->
    <!--          <div class="content-title">-->
    <!--            {{ timeFix }}，{{ nickname }}<span class="welcome-text"></span>-->
    <!--          </div>-->
    <!--          &lt;!&ndash;<div> {{ postGroup }} | {{ user.dept&&user.dept.deptName }}</div>&ndash;&gt;-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </template>-->


    <div style="width: 100%;display: flex;">
      <div style="width: 100%">
        <template>
          <div class="page-header-index-wide">

            <a-row :gutter="24">
              <!--              <a-col :sm="18" :md="10" :xl="4" :style="{ marginBottom: '24px' }">-->
              <!--                <chart-card title="用户总数量" :total="totalNum">-->
              <!--                  <template slot="footer"><span>用户总数量</span></template>-->
              <!--                </chart-card>-->
              <!--              </a-col>-->


              <a-col :sm="6" :md="6" :xl="6" :style="{ marginBottom: '24px' }">
                <a-card style="width: 100%">
                  <p v-if="userFlag=='a'">{{ '今日   |   新增用户数' }}</p>
                  <p v-if="userFlag=='a'">{{ this.data(1) }}</p>
                  <p v-if="userFlag=='b'">{{ '昨日   |   新增用户数' }}</p>
                  <p v-if="userFlag=='b'">{{ this.data(2) }}</p>
                  <p v-if="userFlag=='c'">{{ '近七日   |   新增用户数' }}</p>
                  <p v-if="userFlag=='c'">{{ this.data(3) }}</p>
                  <p><font size="6px">{{ userNum }}</font></p>
                  <a-radio-group default-value="a" @change="(e) => updateUser(e.target.value)" button-style="solid">
                    <a-radio-button value="a">
                      今日
                    </a-radio-button>
                    <a-radio-button value="b">
                      昨日
                    </a-radio-button>
                    <a-radio-button value="c">
                      近七日
                    </a-radio-button>
                  </a-radio-group>
                </a-card>
              </a-col>


              <a-col :sm="6" :md="6" :xl="6" :style="{ marginBottom: '24px' }">
                <a-card style="width: 100%">
                  <p v-if="diominFlag=='a'">{{ '今日   |   累计充值金币收入' }}</p>
                  <p v-if="diominFlag=='a'">{{ this.data(1) }}</p>
                  <p v-if="diominFlag=='b'">{{ '昨日   |   累计充值金币收入' }}</p>
                  <p v-if="diominFlag=='b'">{{ this.data(2) }}</p>
                  <p v-if="diominFlag=='c'">{{ '近七日   |   累计充值金币收入' }}</p>
                  <p v-if="diominFlag=='c'">{{ this.data(3) }}</p>
                  <p><font size="6px">{{ totalNum }}</font></p>
                  <a-radio-group default-value="a" @change="(e) => updateDiomn(e.target.value)" button-style="solid">
                    <a-radio-button value="a">
                      今日
                    </a-radio-button>
                    <a-radio-button value="b">
                      昨日
                    </a-radio-button>
                    <a-radio-button value="c">
                      近七日
                    </a-radio-button>
                  </a-radio-group>
                </a-card>
              </a-col>


              <a-col :sm="6" :md="6" :xl="6" :style="{ marginBottom: '24px' }">
                <a-card style="width: 100%">
                  <p v-if="vipFlag=='a'">{{ '今日   |   累计购买会员收入' }}</p>
                  <p v-if="vipFlag=='a'">{{ this.data(1) }}</p>
                  <p v-if="vipFlag=='b'">{{ '昨日   |   累计购买会员收入' }}</p>
                  <p v-if="vipFlag=='b'">{{ this.data(2) }}</p>
                  <p v-if="vipFlag=='c'">{{ '近七日   |   累计购买会员收入' }}</p>
                  <p v-if="vipFlag=='c'">{{ this.data(3) }}</p>
                  <p><font size="6px">{{ manNum }}</font></p>
                  <a-radio-group default-value="a" @change="(e) => updateVip(e.target.value)" button-style="solid">
                    <a-radio-button value="a">
                      今日
                    </a-radio-button>
                    <a-radio-button value="b">
                      昨日
                    </a-radio-button>
                    <a-radio-button value="c">
                      近七日
                    </a-radio-button>
                  </a-radio-group>
                </a-card>
              </a-col>


              <a-col :sm="6" :md="6" :xl="6" :style="{ marginBottom: '24px' }">
                <a-card style="width: 100%">
                  <p v-if="buyFlag=='a'">{{ '今日   |   累计购买剧集收入' }}</p>
                  <p v-if="buyFlag=='a'">{{ this.data(1) }}</p>
                  <p v-if="buyFlag=='b'">{{ '昨日   |   累计购买剧集收入' }}</p>
                  <p v-if="buyFlag=='b'">{{ this.data(2) }}</p>
                  <p v-if="buyFlag=='c'">{{ '近七日   |   累计购买剧集收入' }}</p>
                  <p v-if="buyFlag=='c'">{{ this.data(3) }}</p>
                  <p><font size="6px">{{ '金币数：' + dionNum }}</font></p>
                  <a-radio-group default-value="a" @change="(e) => updateBuy(e.target.value)" button-style="solid">
                    <a-radio-button value="a">
                      今日
                    </a-radio-button>
                    <a-radio-button value="b">
                      昨日
                    </a-radio-button>
                    <a-radio-button value="c">
                      近七日
                    </a-radio-button>
                  </a-radio-group>
                </a-card>
              </a-col>


              <!--              <a-col :sm="18" :md="10" :xl="4" :style="{ marginBottom: '24px' }">-->
              <!--                <chart-card :loading="loading" :title="userFlag=='a'?'今日 | 新增用户数\r\n\t'+this.data():userFlag=='b'?'昨日 | 新增用户数':userFlag=='c'?'近七日 | 新增用户数':''" :total="userNum">-->


              <!--                </chart-card>-->
              <!--              </a-col>-->
              <!--              <a-col :sm="18" :md="10" :xl="4" :style="{ marginBottom: '24px' }">-->
              <!--                <chart-card :loading="loading" title="性别保密用户数量" :total="noNum">-->
              <!--                  <template slot="footer"><span>性别保密用户数量</span></template>-->
              <!--                </chart-card>-->
              <!--              </a-col>-->
              <!--              <a-col :sm="18" :md="10" :xl="4" :style="{ marginBottom: '24px' }">-->
              <!--                <chart-card :loading="loading" title="今日金币充值金额" :total="manNum">-->
              <!--                  <template slot="footer"><span>今日金币充值金额</span></template>-->
              <!--                </chart-card>-->
              <!--              </a-col>-->

              <!--              <a-col :sm="18" :md="10" :xl="4" :style="{ marginBottom: '24px' }">-->
              <!--                <chart-card :loading="loading" title="今日会员购买金额" :total="womanNum">-->
              <!--                  <template slot="footer"><span>今日会员购买金额</span></template>-->
              <!--                </chart-card>-->
              <!--              </a-col>-->


              <!--              <div v-for="(items, index) in instutionList">-->
              <!--                <a-col :sm="18" :md="10" :xl="4" :style="{ marginBottom: '24px' }">-->
              <!--                  <chart-card :loading="loading" title="用户购买剧集日销售额" :total="items.num">-->
              <!--                    <template slot="footer"><span>{{ items.title }}</span></template>-->
              <!--                  </chart-card>-->
              <!--                </a-col>-->
              <!--              </div>-->

              <!--              <div v-for="(items, index) in storeList">-->
              <!--                <a-col :sm="1" :md="2" :xl="4" :style="{ marginBottom: '24px' }" >-->
              <!--                  <chart-card  :loading="loading" title="日增门店量" :total="items.num">-->
              <!--                    <template slot="footer" hidden="hidden">{{ items.title }}</template>-->
              <!--                  </chart-card>-->
              <!--                </a-col>-->
              <!--              </div>-->
            </a-row>

            <!--            <a-row :gutter="24">-->
            <!--              -->
            <!--            </a-row>-->

            <a-row :gutter="24">
              <div style="display:flex;justify-content: space-around;">
                <div id="myChart" :style="{width: '50%', height: '500px'}"></div>
                <div id="myChart4" :style="{width: '50%', height: '500px'}"></div>
              </div>
            </a-row>


            <a-row :gutter="24">
              <div style="display:flex;justify-content: space-around;">
                <div id="myChart1" style="width: 50%" :style="{height: '500px'}"></div>
                <div id="myChart3" style="width: 50%" :style="{height: '500px'}"></div>
              </div>
            </a-row>


            <!--            <a-row :gutter="24">-->
            <!--              <div id="myChart4" :style="{width: '100%', height: '300px'}"></div>-->
            <!--            </a-row>-->
            <!--            <a-row :gutter="24">-->
            <!--              <div>-->
            <!--&lt;!&ndash;                <a-col style="float: left">&ndash;&gt;-->
            <!--&lt;!&ndash;                  <div id="myChart3" :style="{width: '800px', height: '300px'}"></div>&ndash;&gt;-->
            <!--&lt;!&ndash;                </a-col>&ndash;&gt;-->
            <!--                <a-col style="float: left">-->
            <!--                  <div id="myChart4" :style="{width: '800px', height: '300px'}"></div>-->
            <!--                </a-col>-->
            <!--              </div>-->
            <!--            </a-row>-->

          </div>
        </template>
      </div>
    </div>

  </page-header-wrapper>
</template>

<script>
import {timeFix} from '@/utils/util'
import {mapGetters} from 'vuex'
import {PageHeaderWrapper} from '@/components/ProLayout'
import ruoyiLogo from '@/assets/projects/ruoyi.png'
import antdvLogo from '@/assets/projects/antdv.png'
import * as echarts from 'echarts';
import {
  getInstutionByDay,
  getBuyVipData,
  getUserData,
  getRechargePal,
  getALLCollectNum,
  getDiomnData,
  getVipData,
  getUserDayData,
  getRuioDataByDay,
  getBuyData
} from '@/api/system/user'
import ChartCard from './ChartCard'
import moment from 'moment';
import {getSmsTotalBarChart, getSmsTotalPieChart} from "@/api/sms/log";

export default {
  name: 'MoneyData',
  components: {
    PageHeaderWrapper,
    ChartCard
  },
  data() {
    return {
      xInstutiondata: [],
      yInstutiondata1: [],

      xInstutiondata1s: [],
      yInstutiondata1s: [],

      xInstutiondata4: [],
      yInstutiondata4: [],
      yInstutiondata4s: [],


      yInstutiondata2: [],
      userFlag: 'a',
      diominFlag: 'a',
      vipFlag: 'a',
      buyFlag: 'a',
      xStroredata: [],
      yStroredata1: [],
      yStroredata2: [],

      xUserdata: [],
      yUserdata1: [],
      yUserdata2: [],
      rechargeData: [],

      xdevicedata: [],
      ydevicedata1: [],
      ydevicedata2: [],

      userDayOneData: [],
      userDayTwoData: [],

      totalNum: "0",
      userNum: "0",
      noNum: "0",
      manNum: "0",
      womanNum: "0",
      dionNum: "0",
      instutionList: [],
      storeList: [],
      loading: false,
      // 贡献者
      contributors: [
        {
          name: 'wangze',
          avatar: 'https://portrait.gitee.com/uploads/avatars/user/1662/4988475_fuzui_1586973704.png!avatar60',
          email: '73400@163.com'
        }
      ],
      // 赞助
      sponsorList: [
        {
          key: 'RuoYi',
          tab: 'RuoYi'
        },
        {
          key: 'Antdv',
          tab: 'Antdv'
        }
      ],
      noTitleKey: 'RuoYi',
      timeFix: timeFix(),
      // 用户信息
      user: {
        dept: {
          deptName: ''
        }
      },
      roleGroup: {},
      postGroup: {},
      // 致谢项目
      projects: [
        {
          logo: ruoyiLogo,
          name: 'RuoYi-Vue',
          description: '基于SpringBoot，Spring Security，JWT，Vue & Element 的前后端分离权限管理系统。',
          website: 'http://ruoyi.vip',
          downloadUrl: 'https://gitee.com/y_project/RuoYi-Vue'
        },
        {
          logo: antdvLogo,
          name: 'Ant Design Vue',
          description: 'An enterprise-class UI components based on Ant Design and Vue. ',
          website: 'https://antdv.com',
          downloadUrl: 'https://github.com/vueComponent/ant-design-vue/'
        },
        {
          logo: antdvLogo,
          name: 'Antd Pro Vue',
          description: 'An out-of-box UI solution for enterprise applications as a Vue boilerplate. based on Ant Design of Vue.',
          website: 'https://pro.antdv.com',
          downloadUrl: 'https://github.com/vueComponent/ant-design-vue/'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'avatar',
      'nickname'
    ])
  },
  created() {
    this.getUser()
    this.updateUser('a')
    this.updateDiomn('a')
    this.updateVip('a')
    this.updateBuy('a')
    this.drawLine1()
    this.drawLine4()
    // this.getALLCollection()
  },
  mounted() {
    this.drawLine1();
    this.drawLine2();
    this.drawLine3();
    this.drawLine4();
  },
  methods: {
    updateUser(value) {
      console.log(value)
      this.userFlag = value
      getUserData({
        type: value
      }).then(res => {
        const data = res.data;
        this.userNum = data + "";
      });
    },
    updateDiomn(value) {
      this.diominFlag = value
      getDiomnData({
        type: value
      }).then(res => {
        const data = res.data;
        this.totalNum = data + "";
      });
    },
    updateVip(value) {
      this.vipFlag = value
      getVipData({
        type: value
      }).then(res => {
        const data = res.data;
        this.manNum = data + "";
      });
    },
    updateBuy(value) {
      this.buyFlag = value
      getBuyData({
        type: value
      }).then(res => {
        const data = res.data;

        data.forEach((el) => {
          if (el.type == '1') {
            this.womanNum = el.price + "";
          }
          if (el.type == '2') {
            this.dionNum = el.price + "";
          }
        });
      });
    },
    // 获取用户信息
    getUser() {
      getUserProfile().then(response => {
        window.console.log('response 111', response)
        this.user = response.data
        this.roleGroup = response.roleGroup
        this.postGroup = response.postGroup
      })
    },
    data(value) {
      if (value === 1) {
        var today = new Date();
        var year = today.getFullYear();//获取年份
        var month = today.getMonth() + 1;//获取月份
        var day = today.getDate();//获取日期
        return year + "-" + month + "-" + day + '~' + year + "-" + month + "-" + day
      }
      if (value === 2) {
        var today = new Date();
        var yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
        return yesterday.getFullYear() + "-" + (yesterday.getMonth() + 1) + "-" + yesterday.getDate() + '~' + yesterday.getFullYear() + "-" + (yesterday.getMonth() + 1) + "-" + yesterday.getDate()
      }

      if (value === 3) {
        var today = new Date();
        var yesterday = new Date(today.getTime() - 144 * 60 * 60 * 1000);
        var yesterdays = new Date(today.getTime());
        return yesterday.getFullYear() + "-" + (yesterday.getMonth() + 1) + "-" + yesterday.getDate() + '~' + yesterdays.getFullYear() + "-" + (yesterdays.getMonth() + 1) + "-" + yesterdays.getDate()
      }
    },


    onSponsorTabChange(key, type) {
      this[type] = key
    },
    collectionCount() {
      getInstutionByDay().then(res => {
        if (res.data) {
          const data = res.data;
          data.forEach((el) => {
            const obj = {}
            obj.num = el.price;
            obj.title = el.times;
            this.instutionList.push(obj);
          });
        }
      });
      // /*门店日增*/
      // getStoreByDay().then(res => {
      //   if (res.data){
      //     const data = res.data;
      //     data.forEach((el) => {
      //       const obj = {}
      //       obj.num = el.num;
      //       obj.title = el.time;
      //       this.storeList.push(obj);
      //     });
      //   }
      // });
    },
    getALLCollection() {
      //统计（机构总数量、门店总数量、用户总数量、设备总数量）
      getALLCollectNum().then(res => {
        if (res.data) {
          const data = res.data;
          this.totalNum = data.totalNum + "";
          this.userNum = data.userNum + "";
          this.noNum = data.noNum + "";
          this.manNum = data.manNum + "";
          this.womanNum = data.womanNum + "";
        }
      });
    },

    drawLine1() {
      //获取机构概览
      getInstutionByDay().then(res => {
        this.xInstutiondata = [];
        this.yInstutiondata1 = [];
        this.xInstutiondata1s = [];
        this.yInstutiondata1s = [];
        if (res.data) {
          const data = res.data.orderNum;//  订单量
          data.forEach((el) => {
            this.xInstutiondata.push(el.times);
            this.yInstutiondata1.push(Number(el.nums));
          });
          res.data.orderMoney.forEach((el) => {
            // this.xInstutiondata1s.push(el.times);
            this.yInstutiondata1s.push(Number(el.moneys));
          });
          // debugger
          // console.log(this.xInstutiondata)
          // data1.forEach((el) => {
          //   this.yInstutiondata2.push(Number(el.num));
          // });

          // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例  myChart1
          let myChart = echarts.init(document.getElementById('myChart'));
          var option = {
            title: {
              text: '  用户充值概览'
            },
            tooltip: {
              trigger: 'item',
              triggerOn: "mousemove",
            },
            legend: {
              data: ['充值收入', '充值订单数']
            },


            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: this.xInstutiondata
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: '充值订单数',
                type: 'line',
                stack: 'Total',
                data: this.yInstutiondata1
              },
              {
                name: '充值收入',
                type: 'line',
                stack: 'Total',
                data: this.yInstutiondata1s
              }
            ]
          };
          // 绘制图表
          // myChart.setOption(option);
          option && myChart.setOption(option);
        }
      });

    },

    drawLine2() {
      getRuioDataByDay().then(res => {
        this.dataList = [];
        if (res.data) {
          this.dataList = res.data;//  每日总量
          var chartDom = document.getElementById('myChart1');
          var myChart = echarts.init(chartDom);
          var option;

          option = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '5%',
              left: 'center'
            },
            series: [
              {
                name: '数据值',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                padAngle: 5,
                itemStyle: {
                  borderRadius: 10
                },
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 40,
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: false
                },
                data: this.dataList
              }
            ]
          };

          option && myChart.setOption(option);

          //1111
        }
      });
    },
    drawLine3() {
      getRechargePal().then(res => {
            this.rechargeData = [];
            if (res.data) {
              this.rechargeData = res.data;//  每日总量
              var chartDom = document.getElementById('myChart3');
              var myChart = echarts.init(chartDom);
              var option;
              option = {
                tooltip: {
                  trigger: 'item'
                },
                legend: {
                  top: '5%',
                  left: 'center'
                },
                series: [
                  {
                    name: '充值数',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    avoidLabelOverlap: false,
                    padAngle: 5,
                    itemStyle: {
                      borderRadius: 10
                    },
                    label: {
                      show: false,
                      position: 'center'
                    },
                    emphasis: {
                      label: {
                        show: true,
                        fontSize: 40,
                        fontWeight: 'bold'
                      }
                    },
                    labelLine: {
                      show: false
                    },
                    data: this.rechargeData
                  }
                ]
              };

              option && myChart.setOption(option);
            }
      });
    },
          drawLine4(){
        //获取机构概览
        getBuyVipData().then(res => {
          this.xInstutiondata4 = [];
          this.yInstutiondata4 = [];
          this.yInstutiondata4s = [];
          if (res.data) {
            const data = res.data.orderNum;//  订单量
            data.forEach((el) => {
              this.xInstutiondata4.push(el.times);
              this.yInstutiondata4.push(Number(el.nums));
            });
            res.data.orderMoney.forEach((el) => {
              // this.xInstutiondata4.push(el.times);
              this.yInstutiondata4s.push(Number(el.moneys));
            });
            // debugger
            // console.log(this.xInstutiondata)
            // data1.forEach((el) => {
            //   this.yInstutiondata2.push(Number(el.num));
            // });

            // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例  myChart1
            let myChart4 = echarts.init(document.getElementById('myChart4'));
            var option = {
              title: {
                text: '  会员订阅概览'
              },
              tooltip: {
                trigger: 'item',
                triggerOn: "mousemove",
              },
              legend: {
                data: ['订阅收入', '订阅数']
              },


              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              toolbox: {
                feature: {
                  saveAsImage: {}
                }
              },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: this.xInstutiondata4
              },
              yAxis: {
                type: 'value'
              },
              series: [
                {
                  name: '订阅数',
                  type: 'line',
                  stack: 'Total',
                  data: this.yInstutiondata4
                },
                {
                  name: '订阅收入',
                  type: 'line',
                  stack: 'Total',
                  data: this.yInstutiondata4s
                }
              ]
            };
            // 绘制图表
            // myChart.setOption(option);
            option && myChart4.setOption(option);
          }
        });
      }

    },
  }
</script>

<style lang="less" scoped>
@import "./index.less";

blockquote {
  padding: 0 1em;
  color: #6a737d;
  border-left: 0.25em solid #dfe2e5;
}

.project-list {

  .card-title {
    font-size: 0;

    a {
      color: rgba(0, 0, 0, 0.85);
      margin-left: 12px;
      line-height: 24px;
      height: 24px;
      display: inline-block;
      vertical-align: top;
      font-size: 14px;

      &:hover {
        color: #1890ff;
      }
    }
  }

  .card-description {
    color: rgba(0, 0, 0, 0.45);
    height: 66px;
    line-height: 22px;
    overflow: hidden;
  }

  .project-item {
    display: flex;
    margin-top: 8px;
    overflow: hidden;
    font-size: 12px;
    height: 20px;
    line-height: 20px;

    a {
      color: rgba(0, 0, 0, 0.45);
      display: inline-block;
      flex: 1 1 0;

      &:hover {
        color: #1890ff;
      }
    }

    .download {
      color: rgba(0, 0, 0, 0.25);
      flex: 0 0 auto;
      float: right;
    }
  }

  .ant-card-meta-description {
    color: rgba(0, 0, 0, 0.45);
    height: 44px;
    line-height: 22px;
    overflow: hidden;
  }
}

.item-group {
  padding: 20px 0 8px 24px;
  font-size: 0;

  a {
    color: rgba(0, 0, 0, 0.65);
    display: inline-block;
    font-size: 14px;
    margin-bottom: 13px;
    width: 25%;
  }
}

.mobile {

  .project-list {

    .project-card-grid {
      width: 100%;
    }
  }

  .more-info {
    border: 0;
    padding-top: 16px;
    margin: 16px 0 16px;
  }

  .headerContent .title .welcome-text {
    display: none;
  }
}

</style>
